<template>
  <div v-if="courseContents" class="py-20" :class="backgroundGreen ? 'bg-br-green-light' : 'bg-putty'">
    <div class="container">
      <div class="max-w-screen-md mx-auto">
        <h2 class="fluid-3xl leading-tightest mb-16 text-center">{{ $t('courseContent.title') }}</h2>
      </div>
    </div>
    <div class="max-w-screen-md mx-auto">
      <BorderedAccordion
        v-for="(panel, index) in courseContents.sections"
        :key="index"
        :itemNumber="showChapterNumbers ? index : null"
        :heading="panel.sectionTitle"
        :body="panel.sectionDescription"
        :categories="countCategories(panel.unitSummary)"
        :is-open="index === 0"
        class="last:border-b"
      />
    </div>
  </div>
</template>

<script>
import BorderedAccordion from '~/components/common/BorderedAccordion';
import { fetchCourseContent } from '~/utils/feg';
import * as Sentry from '@sentry/vue';

export default defineNuxtComponent({
  components: {
    BorderedAccordion,
  },

  props: {
    backgroundGreen: {
      type: Boolean,
      default: false,
    },
    course: {
      type: String,
      default: null,
    },
    showChapterNumbers: {
      type: Boolean,
      default: false,
    },
    courseData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      courseContents: this.courseData || null,
      active: false,
    };
  },

  async created() {
    if (this.courseData) {
      return;
    }

    if (this.course && this.course === 'null') {
      return;
    }

    try {
      const courseContentsResponse = await useAsyncData('courseContents', () => {
        return fetchCourseContent(this.course);
      });

      this.courseContents = courseContentsResponse.data;
    } catch (error) {
      console.error('Error fetching course content:', error);
      Sentry.captureException(error);
    }
  },

  methods: {
    countCategories(categories) {
      if (!categories) return [];

      if (categories && Array.isArray(categories)) {
        const categoriesList = {};

        categories.forEach((item) => {
          const key =
            item.key === 'video' || item.key === 'ebook'
              ? this.$t(`courseContent.${item.key}`)
              : this.$t('courseContent.other');

          if (categoriesList[key]) {
            categoriesList[key].count += item.count;
          } else {
            categoriesList[key] = {
              name: key,
              count: item.count,
            };
          }
        });

        return Object.values(categoriesList);
      }
    },
  },
});
</script>
